export default __webpack_public_path__ + "static/media/img15.c519873f.jpg";